import { render, staticRenderFns } from "./BaseIcon.vue?vue&type=template&id=39d08d9f&"
import script from "./BaseIcon.vue?vue&type=script&lang=ts&"
export * from "./BaseIcon.vue?vue&type=script&lang=ts&"
import style0 from "./BaseIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports